import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

type ITrainingSetResetValidationRulesMutationParams = {
  trainingSetId: string;
};

export const useTrainingSetResetValidationRules = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: ITrainingSetResetValidationRulesMutationParams) => {
      return await (await glynt).trainingSet.resetValidationRules(data.trainingSetId);
    },

    ...callbacks
  });
};
